import { BlocksIconInfoFilled } from 'blocks-nextjs/blocks-web-components/components/icon/icons/info-filled';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconInfoFilled = createComponent({
  react: React,
  tagName: 'cat-icon-info-filled',
  elementClass: BlocksIconInfoFilled
});
